// Shared "is this navbar item active" check used consistently by the top-level
// item, the collapsed hover flyout and the expanded sub-page links, so all
// three tiers agree on which section is highlighted for a given pathname.
const isRouteActive = (pathname, url, subPaths = []) => pathname === url || subPaths.some((subPath) => pathname === subPath || pathname.startsWith(`${subPath}/`));

export default isRouteActive;
